import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import EmailLogin from "./EmailLogin";
// import logopageimg from "../../assets/images/logopageimg.jpg";
import UserRegistration from "./UserRegistration"; // Import your UserRegistration component

function LoginScreen() {
  const navigate = useNavigate();
  const imageContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 50, y: 50 });
  const [distanceFromCenter, setDistanceFromCenter] = useState(0);
  const [showRegistration, setShowRegistration] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    if (isLoggedIn) {
      navigate("/home");
    }
  }, [isLoggedIn, navigate]);

  const handleMouseMove = (e) => {
    if (!imageContainerRef.current) return;

    const { left, top, width, height } =
      imageContainerRef.current.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setMousePosition({ x, y });

    const centerX = 50;
    const centerY = 50;
    const currentDistance = Math.sqrt(
      Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2)
    );
    const maxDistance = Math.sqrt(Math.pow(50, 2) + Math.pow(50, 2));
    const normalizedDistance = Math.pow(currentDistance / maxDistance, 0.7);

    setDistanceFromCenter(normalizedDistance);
  };

  const handleRegistrationClick = () => {
    setShowRegistration(true);
  };

  const handleBackToLogin = () => {
    setShowRegistration(false);
  };

  //If showRegistration is true, render the UserRegistration component
  if (showRegistration) {
    return (
      <UserRegistration 
        onBackToLogin={handleBackToLogin}
        primaryColor="#3f51b5" 
        secondaryColor="#f5f5f5"
        textColor="#333333"
        borderColor="#ddd"
      />
    );
  }

  return (
    <div className="login-page-wrapper">
      <div className="login-container">
        <div className="login-card">
          {/* Left Pane - Image Section */}
          <div className="left-pane">
           
              <div
                ref={imageContainerRef}
                className={`image-container ${isHovered ? "hovered" : ""}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => {
                  setIsHovered(false);
                  setDistanceFromCenter(0);
                }}
                onMouseMove={handleMouseMove}
                style={{
                  transform: isHovered
                    ? `
                      scale(${1 + (1 - distanceFromCenter) * 0.25})
                      translateZ(${(1 - distanceFromCenter) * 80}px)
                      rotateX(${(mousePosition.y - 50) * -0.5}deg)
                      rotateY(${(mousePosition.x - 50) * 0.5}deg)
                    `
                    : "none",
                  transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                }}
              >
                <img src={"./Images/logopageimg.jpg"} alt="Logo" className="gsg-logo" />
               
              </div>
            
          </div>

          {/* Right Pane - Form Section */}
          <div className="right-pane">
            <div className="form-content">
              {/* Pass the registration handler to EmailLogin */}
              <EmailLogin 
                onLoginSuccess={() => setIsLoggedIn(true)}
                onRegisterClick={handleRegistrationClick}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;